import React from 'react';
import PropTypes from 'prop-types';
import loadWowHead from '../html/thirdParty/WowHead/loadWowHead';
import loadLightgg from '../html/thirdParty/LightGG/loadLightgg';
import {addTargetToLinks} from "../../utils/addTargetToLinks";

const wowHeadRegexp = /wowhead.com/im;
const lightGgRegexp = /light.gg/im;

export default class RawHtml extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    element: PropTypes.string,
    content: PropTypes.string
  };

  checkRegexp = (str, regexp) => {
    return regexp.test(str);
  }

  componentDidMount() {
    const str = this.props.content;

    if (this.checkRegexp(str, wowHeadRegexp)) {
      if (window.$WowheadPower === undefined) {
        loadWowHead();
      } else {
        try {
          window.$WowheadPower.refreshLinks();
        } catch (e) {
          // Intentionally blank
        }
      }
    }

    if (this.checkRegexp(str, lightGgRegexp)) {
      if (window.lgg === undefined) {
        loadLightgg();
      } else {
        try {
          window.lgg.renameLinks();
          window.lgg.recolorLinks();
        } catch (e) {
          // Intentionally blank
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content) {
      const str = this.props.content;

      if (this.checkRegexp(str, wowHeadRegexp)) {
        if (window.$WowheadPower === undefined) {
          loadWowHead();
        } else {
          try {
            window.$WowheadPower.refreshLinks();
          } catch (e) {
            // Intentionally blank
          }
        }
      }

      if (this.checkRegexp(str, lightGgRegexp)) {
        if (window.lgg === undefined) {
          loadLightgg();
        } else {
          try {
            window.lgg.renameLinks();
            window.lgg.recolorLinks();
          } catch (e) {
            // Intentionally blank
          }
        }
      }
    }
  }

  componentWillUnmount() {
    if (window.$WowheadPower) {
      try {
        window.$WowheadPower.hideTooltip();
      } catch (e) {
        // Intentionally blank
      }
    }

    if (window.lgg) {
      try {
        window.lgg.cancel();
      } catch (e) {
        // Intentionally blank
      }
    }
  }

  render() {
    const {className, content, element = 'div'} = this.props;

    const modifiedContent = addTargetToLinks(content);
    const Component = element;

    return (
      <Component className={className} dangerouslySetInnerHTML={{__html: modifiedContent}}/>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rawHtml/RawHtml.js